

// import React, { useState } from "react";
// import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
// import "../css/ContactForm.css";

// const countryCodes = {
//   Afghanistan: "+93",
//   Albania: "+355",
//   Algeria: "+213",
//   Andorra: "+376",
//   Angola: "+244",
//   "Antigua and Barbuda": "+1-268",
//   Argentina: "+54",
//   Armenia: "+374",
//   Australia: "+61",
//   Austria: "+43",
//   Azerbaijan: "+994",
//   Bahamas: "+1-242",
//   Bahrain: "+973",
//   Bangladesh: "+880",
//   Barbados: "+1-246",
//   Belarus: "+375",
//   Belgium: "+32",
//   Belize: "+501",
//   Benin: "+229",
//   Bhutan: "+975",
//   Bolivia: "+591",
//   "Bosnia and Herzegovina": "+387",
//   Botswana: "+267",
//   Brazil: "+55",
//   Brunei: "+673",
//   Bulgaria: "+359",
//   "Burkina Faso": "+226",
//   Burundi: "+257",
//   Canada: "+1",
//   China: "+86",
//   "Democratic Republic of the Congo": "+243",
//   Denmark: "+45",
//   Egypt: "+20",
//   France: "+33",
//   Germany: "+49",
//   India: "+91",
//   Indonesia: "+62",
//   Iran: "+98",
//   Iraq: "+964",
//   Ireland: "+353",
//   Israel: "+972",
//   Italy: "+39",
//   Japan: "+81",
//   Kenya: "+254",
//   Malaysia: "+60",
//   Mexico: "+52",
//   Nepal: "+977",
//   Netherlands: "+31",
//   "New Zealand": "+64",
//   Nigeria: "+234",
//   Norway: "+47",
//   Pakistan: "+92",
//   Philippines: "+63",
//   Russia: "+7",
//   "Saudi Arabia": "+966",
//   "South Africa": "+27",
//   Spain: "+34",
//   "United Arab Emirates": "+971",
//   "United Kingdom": "+44",
//   "United States": "+1",
// };

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     company: "",
//     country: "",
//     contactType: "",
//     message: "",
//     termsAccepted: false,
//   });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     let updatedValue = value;

//     if (name === "country") {
//       const countryCode = countryCodes[value] || "";
//       setFormData((prev) => ({
//         ...prev,
//         country: value,
//         phone: countryCode,
//       }));
//       return;
//     }

//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : updatedValue,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form submitted:", formData);
//   };

//   return (
//     <div className="contact-container">
//       {/* <div className="contact-info">
//         <h2>Contact Information</h2>
//         <p>
//           <FaMapMarkerAlt /> Royal Wave Biotech Private Limited (Dr.Chek) Ground
//           Floor, House 7-100/69, Plot No.69, Balaji Nagar Colony, Qutubullapur,
//           Nizampet, Hyderabad, Telangana 500090 Phone: +91-9494981234
//         </p>
//         <p>
//           <FaPhone /> +91-9494981234
//         </p>
//         <p>
//           <FaEnvelope /> info@drchek.com
//         </p>
//         <img
//           src="https://skyhitmedia.in/media/contact-banner.jpg"
//           alt="Sample Image"
//         />
//       </div> */}

// <div className="contact-info">
//   <h2>Contact Information</h2>
//   <p>
//     <FaMapMarkerAlt style={{ fontSize: "20px", marginRight: "10px" }} />
//     Royal Wave Biotech Private Limited (Dr.Chek) Ground Floor, House 7-100/69, 
//     Plot No.69, Balaji Nagar Colony, Qutubullapur, Nizampet, Hyderabad, Telangana 500090
//   </p>
//   <p>
//     <FaPhone style={{ fontSize: "20px", marginRight: "10px" }} /> +91-9494981234
//   </p>
//   <p>
//     <FaEnvelope style={{ fontSize: "20px", marginRight: "10px" }} /> info@drchek.com
//   </p>
//   <img
//     src="https://skyhitmedia.in/media/contact-banner.jpg"
//     alt="Sample Image"
//   />
// </div>


//       <div className="contact-form">
//         <h2>Contact Us</h2>
//         <form onSubmit={handleSubmit}>
//           <div className="form-row">
//             <div className="form-group">
//               <label>Name</label>
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Enter name"
//                 required
//                 value={formData.name}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="form-group">
//               <label>Email</label>
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Enter email"
//                 required
//                 value={formData.email}
//                 onChange={handleChange}
//               />
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="form-group">
//               <label>Country</label>
//               <select
//                 name="country"
//                 required
//                 value={formData.country}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Country</option>
//                 {Object.keys(countryCodes).map((country, index) => (
//                   <option key={index} value={country}>
//                     {country}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="form-group">
//               <label>Contact Type</label>
//               <select
//                 name="contactType"
//                 required
//                 value={formData.contactType}
//                 onChange={handleChange}
//               >
//                 <option value="">Select</option>
//                 <option value="general">General Inquiry</option>
//                 <option value="support">Support</option>
//                 <option value="business">Business Inquiry</option>
//               </select>
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="form-group">
//               <label>Phone</label>
//               <input
//                 type="tel"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="form-group">
//               <label>Company</label>
//               <input
//                 type="text"
//                 name="company"
//                 placeholder="Enter company"
//                 value={formData.company}
//                 onChange={handleChange}
//               />
//             </div>
//           </div>

//           <div className="form-group">
//             <label>Message</label>
//             <textarea
//               name="message"
//               placeholder="Enter your message"
//               required
//               value={formData.message}
//               onChange={handleChange}
//             ></textarea>
//           </div>

//           <div className="checkbox-group">
//             <input
//               type="checkbox"
//               name="termsAccepted"
//               required
//               checked={formData.termsAccepted}
//               onChange={handleChange}
//             />
//             <label>
//               I accept the terms & conditions and acknowledge the privacy
//               policy.
//             </label>
//           </div>

//           <button type="submit" className="submit-btn">
//             Submit
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ContactForm;





// import React, { useState } from "react";
// import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
// import ReCAPTCHA from "react-google-recaptcha";
// import "../css/ContactForm.css";

// const countryCodes = {
//   Afghanistan: "+93",
//   Albania: "+355",
//   Algeria: "+213",
//   Andorra: "+376",
//   Angola: "+244",
//   "Antigua and Barbuda": "+1-268",
//   Argentina: "+54",
//   Armenia: "+374",
//   Australia: "+61",
//   Austria: "+43",
//   Azerbaijan: "+994",
//   Bahamas: "+1-242",
//   Bahrain: "+973",
//   Bangladesh: "+880",
//   Barbados: "+1-246",
//   Belarus: "+375",
//   Belgium: "+32",
//   Belize: "+501",
//   Benin: "+229",
//   Bhutan: "+975",
//   Bolivia: "+591",
//   "Bosnia and Herzegovina": "+387",
//   Botswana: "+267",
//   Brazil: "+55",
//   Brunei: "+673",
//   Bulgaria: "+359",
//   "Burkina Faso": "+226",
//   Burundi: "+257",
//   Canada: "+1",
//   China: "+86",
//   "Democratic Republic of the Congo": "+243",
//   Denmark: "+45",
//   Egypt: "+20",
//   France: "+33",
//   Germany: "+49",
//   India: "+91",
//   Indonesia: "+62",
//   Iran: "+98",
//   Iraq: "+964",
//   Ireland: "+353",
//   Israel: "+972",
//   Italy: "+39",
//   Japan: "+81",
//   Kenya: "+254",
//   Malaysia: "+60",
//   Mexico: "+52",
//   Nepal: "+977",
//   Netherlands: "+31",
//   "New Zealand": "+64",
//   Nigeria: "+234",
//   Norway: "+47",
//   Pakistan: "+92",
//   Philippines: "+63",
//   Russia: "+7",
//   "Saudi Arabia": "+966",
//   "South Africa": "+27",
//   Spain: "+34",
//   "United Arab Emirates": "+971",
//   "United Kingdom": "+44",
//   "United States": "+1",
// };

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     company: "",
//     country: "",
//     contactType: "",
//     message: "",
//     termsAccepted: false,
//   });

//   const [captchaVerified, setCaptchaVerified] = useState(false);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (name === "country") {
//       const countryCode = countryCodes[value] || "";
//       setFormData((prev) => ({
//         ...prev,
//         country: value,
//         phone: countryCode,
//       }));
//       return;
//     }

//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   const handleCaptcha = (value) => {
//     if (value) {
//       setCaptchaVerified(true);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!captchaVerified) {
//       alert("Please verify the reCAPTCHA!");
//       return;
//     }

//     console.log("Form submitted:", formData);
//   };

//   return (
//     <div className="contact-container">
//       <div className="contact-info">
//         <h2>Contact Information</h2>
//         <p>
//           <FaMapMarkerAlt style={{ fontSize: "20px", marginRight: "10px" }} />
//           Royal Wave Biotech Private Limited (Dr.Chek) Ground Floor, House 7-100/69, 
//           Plot No.69, Balaji Nagar Colony, Qutubullapur, Nizampet, Hyderabad, Telangana 500090
//         </p>
//         <p>
//           <FaPhone style={{ fontSize: "20px", marginRight: "10px" }} /> +91-9494981234
//         </p>
//         <p>
//           <FaEnvelope style={{ fontSize: "20px", marginRight: "10px" }} /> info@drchek.com
//         </p>
//         <img
//           src="https://skyhitmedia.in/media/contact-banner.jpg"
//           alt="Sample Image"
//         />
//       </div>

//       <div className="contact-form">
//         <h2>Contact Us</h2>
//         <form onSubmit={handleSubmit}>
//           <div className="form-row">
//             <div className="form-group">
//               <label>Name</label>
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Enter name"
//                 required
//                 value={formData.name}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="form-group">
//               <label>Email</label>
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Enter email"
//                 required
//                 value={formData.email}
//                 onChange={handleChange}
//               />
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="form-group">
//               <label>Country</label>
//               <select
//                 name="country"
//                 required
//                 value={formData.country}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Country</option>
//                 {Object.keys(countryCodes).map((country, index) => (
//                   <option key={index} value={country}>
//                     {country}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="form-group">
//               <label>Contact Type</label>
//               <select
//                 name="contactType"
//                 required
//                 value={formData.contactType}
//                 onChange={handleChange}
//               >
//                 <option value="">Select</option>
//                 <option value="general">General Inquiry</option>
//                 <option value="support">Support</option>
//                 <option value="business">Business Inquiry</option>
//               </select>
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="form-group">
//               <label>Phone</label>
//               <input
//                 type="tel"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="form-group">
//               <label>Company</label>
//               <input
//                 type="text"
//                 name="company"
//                 placeholder="Enter company"
//                 value={formData.company}
//                 onChange={handleChange}
//               />
//             </div>
//           </div>

//           <div className="form-group">
//             <label>Message</label>
//             <textarea
//               name="message"
//               placeholder="Enter your message"
//               required
//               value={formData.message}
//               onChange={handleChange}
//             ></textarea>
//           </div>

//           <div className="checkbox-group">
//             <input
//               type="checkbox"
//               name="termsAccepted"
//               required
//               checked={formData.termsAccepted}
//               onChange={handleChange}
//             />
//             <label>
//               I accept the terms & conditions and acknowledge the privacy
//               policy.
//             </label>
//           </div>

//           {/* Google reCAPTCHA */}
//           <div className="recaptcha-container">
//             <ReCAPTCHA
//               sitekey="6LdmugIrAAAAAIblFaSnd474Ym5XSsEioE15plUv"
//               onChange={handleCaptcha}
//             />
//           </div>

//           <button type="submit" className="submit-btn">
//             Submit
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ContactForm;



// import React, { useState } from "react";
// import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
// import ReCAPTCHA from "react-google-recaptcha";
// import emailjs from "@emailjs/browser";
// import "../css/ContactForm.css";

// const countryCodes = {
//   Afghanistan: "+93",
//   Albania: "+355",
//   Algeria: "+213",
//   Andorra: "+376",
//   Angola: "+244",
//   Argentina: "+54",
//   Australia: "+61",
//   Austria: "+43",
//   Azerbaijan: "+994",
//   Bahamas: "+1-242",
//   Bahrain: "+973",
//   Bangladesh: "+880",
//   Barbados: "+1-246",
//   Belarus: "+375",
//   Belgium: "+32",
//   Belize: "+501",
//   Benin: "+229",
//   Bhutan: "+975",
//   Bolivia: "+591",
//   Brazil: "+55",
//   Bulgaria: "+359",
//   Canada: "+1",
//   China: "+86",
//   Egypt: "+20",
//   France: "+33",
//   Germany: "+49",
//   India: "+91",
//   Indonesia: "+62",
//   Iran: "+98",
//   Iraq: "+964",
//   Italy: "+39",
//   Japan: "+81",
//   Kenya: "+254",
//   Malaysia: "+60",
//   Mexico: "+52",
//   Nepal: "+977",
//   Netherlands: "+31",
//   Nigeria: "+234",
//   Norway: "+47",
//   Pakistan: "+92",
//   Philippines: "+63",
//   Russia: "+7",
//   "Saudi Arabia": "+966",
//   "South Africa": "+27",
//   Spain: "+34",
//   "United Kingdom": "+44",
//   "United States": "+1",
// };

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     company: "",
//     country: "",
//     contactType: "",
//     message: "",
//     termsAccepted: false,
//   });

//   const [captchaVerified, setCaptchaVerified] = useState(false);
//   const [status, setStatus] = useState(""); // Success/Error messages

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (name === "country") {
//       setFormData((prev) => ({
//         ...prev,
//         country: value,
//         phone: countryCodes[value] || "",
//       }));
//       return;
//     }

//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   const handleCaptcha = (value) => {
//     setCaptchaVerified(!!value);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!captchaVerified) {
//       setStatus("❌ Please verify the reCAPTCHA!");
//       return;
//     }

//     setStatus("⏳ Sending message...");

//     const serviceID = "service_i2h82eb";
//     const templateID = "template_rn1vnln";
//     const userID = "your_user_id";

//     emailjs.send(serviceID, templateID, formData, userID)
//       .then(() => {
//         setStatus("✅ Message sent successfully!");
//         setFormData({
//           name: "",
//           email: "",
//           phone: "",
//           company: "",
//           country: "",
//           contactType: "",
//           message: "",
//           termsAccepted: false,
//         });
//       })
//       .catch(() => {
//         setStatus("❌ Failed to send message. Please try again.");
//       });
//   };

//   return (
//     <div className="contact-container">
//       <div className="contact-info">
//         <h2>Contact Information</h2>
//         <p><FaMapMarkerAlt /> Royal Wave Biotech Private Limited , Hyderabad, Telangana 500090</p>
//         <p><FaPhone /> +91-9494981234</p>
//         <p><FaEnvelope /> info@drchek.com</p>
//         <img src="https://skyhitmedia.in/media/contact-banner.jpg" alt="Contact Banner" />
//       </div>

//       <div className="contact-form">
//         <h1>Contact Us</h1>
//         <form onSubmit={handleSubmit}>
//           <div className="form-row">
//             <div className="form-group">
//               <label>Name</label>
//               <input type="text" name="name" placeholder="Enter name" required value={formData.name} onChange={handleChange} />
//             </div>
//             <div className="form-group">
//               <label>Email</label>
//               <input type="email" name="email" placeholder="Enter email" required value={formData.email} onChange={handleChange} />
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="form-group">
//               <label>Country</label>
//               <select name="country" required value={formData.country} onChange={handleChange}>
//                 <option value="">Select Country</option>
//                 {Object.keys(countryCodes).map((country) => (
//                   <option key={country} value={country}>{country}</option>
//                 ))}
//               </select>
//             </div>
//             <div className="form-group">
//               <label>Contact Type</label>
//               <select name="contactType" required value={formData.contactType} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="general">General Inquiry</option>
//                 <option value="support">Support</option>
//                 <option value="business">Business Inquiry</option>
//               </select>
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="form-group">
//               <label>Phone</label>
//               <input type="tel" name="phone" value={formData.phone} onChange={handleChange} />
//             </div>
//             <div className="form-group">
//               <label>Company</label>
//               <input type="text" name="company" placeholder="Enter company" value={formData.company} onChange={handleChange} />
//             </div>
//           </div>

//           <div className="form-group">
//             <label>Message</label>
//             <textarea name="message" placeholder="Enter your message" required value={formData.message} onChange={handleChange}></textarea>
//           </div>

//           <div className="checkbox-group">
//             <input type="checkbox" name="termsAccepted" required checked={formData.termsAccepted} onChange={handleChange} />
//             <label>I accept the terms & conditions and acknowledge the privacy policy.</label>
//           </div>

//           {/* Google reCAPTCHA */}
//           <div className="recaptcha-container">
//             <ReCAPTCHA sitekey="6LdmugIrAAAAAIblFaSnd474Ym5XSsEioE15plUv" onChange={handleCaptcha} />
//           </div>

//           <button type="submit" className="submit-btn">Submit</button>
//         </form>

//         {status && <p className="form-status">{status}</p>}
//       </div>
//     </div>
//   );
// };

// export default ContactForm;



import React, { useState, useEffect } from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "@emailjs/browser";
import "../css/ContactForm.css";

const countryCodes = {
  Afghanistan: "+93",
  Albania: "+355",
  Algeria: "+213",
  Andorra: "+376",
  Angola: "+244",
  Argentina: "+54",
  Australia: "+61",
  Austria: "+43",
  Azerbaijan: "+994",
  Bahamas: "+1-242",
  Bahrain: "+973",
  Bangladesh: "+880",
  Barbados: "+1-246",
  Belarus: "+375",
  Belgium: "+32",
  Belize: "+501",
  Benin: "+229",
  Bhutan: "+975",
  Bolivia: "+591",
  Brazil: "+55",
  Bulgaria: "+359",
  Canada: "+1",
  China: "+86",
  Egypt: "+20",
  France: "+33",
  Germany: "+49",
  India: "+91",
  Indonesia: "+62",
  Iran: "+98",
  Iraq: "+964",
  Italy: "+39",
  Japan: "+81",
  Kenya: "+254",
  Malaysia: "+60",
  Mexico: "+52",
  Nepal: "+977",
  Netherlands: "+31",
  Nigeria: "+234",
  Norway: "+47",
  Pakistan: "+92",
  Philippines: "+63",
  Russia: "+7",
  "Saudi Arabia": "+966",
  "South Africa": "+27",
  Spain: "+34",
  "United Kingdom": "+44",
  "United States": "+1",
};

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    country: "",
    contactType: "",
    message: "",
    subject:"Contact Form",
    page_url: "",
    termsAccepted: false,
  });

  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      page_url: window.location.href, // Capture the current page URL dynamically
    }));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "country") {
      setFormData((prev) => ({
        ...prev,
        country: value,
        phone: countryCodes[value] || "",
      }));
      return;
    }

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleCaptcha = (value) => {
    setCaptchaVerified(!!value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!captchaVerified) {
      setStatus("❌ Please verify the reCAPTCHA!");
      return;
    }

    setStatus("⏳ Sending message...");

    const serviceID = "service_i2h82eb"; // Your EmailJS service ID
    const templateID = "template_rn1vnln"; // Your EmailJS template ID
    const publicKey = "hjLXq5MC66R977QFn"; // Replace with your actual EmailJS Public Key


    emailjs.send(serviceID, templateID, formData, publicKey)
      .then(() => {
        setStatus("✅ Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          country: "",
          contactType: "",
          message: "",
          subject:"Contact Form",
          page_url: window.location.href,
          termsAccepted: false,
        });
      })
      .catch(() => {
        setStatus("❌ Failed to send message. Please try again.");
      });
  };

  return (
    <div className="contact-container">
      <div className="contact-info">
        <h2>Contact Information</h2>
        <p><FaMapMarkerAlt /> Royal Wave Biotech Private Limited
        Ground Floor, House 7-100/69, Plot No.69, Balaji Nagar Colony, Qutubullapur, Nizampet, Hyderabad, Telangana 500090</p>
        <p><FaPhone /> +91-9494981234</p>
        <p><FaEnvelope /> info@drchek.com</p>
        <img src="https://skyhitmedia.in/media/contact-banner.jpg" alt="Contact Banner" />
      </div>

      <div className="contact-form">
        <h1>Contact Us</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Name</label>
              <input type="text" name="name" placeholder="Enter name" required value={formData.name} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" name="email" placeholder="Enter email" required value={formData.email} onChange={handleChange} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Country</label>
              <select name="country" required value={formData.country} onChange={handleChange}>
                <option value="">Select Country</option>
                {Object.keys(countryCodes).map((country) => (
                  <option key={country} value={country}>{country}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Contact Type</label>
              <select name="contactType" required value={formData.contactType} onChange={handleChange}>
                <option value="">Select</option>
                <option value="general">General Inquiry</option>
                <option value="support">Support</option>
                <option value="business">Business Inquiry</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Phone</label>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Company</label>
              <input type="text" name="company" placeholder="Enter company" value={formData.company} onChange={handleChange} />
            </div>
          </div>

          <div className="form-group">
            <label>Message</label>
            <textarea name="message" placeholder="Enter your message" required value={formData.message} onChange={handleChange}></textarea>
          </div>

          <div className="checkbox-group">
            <input type="checkbox" name="termsAccepted" required checked={formData.termsAccepted} onChange={handleChange} />
            <label>I accept the terms & conditions and acknowledge the privacy policy.</label>
          </div>

          {/* Google reCAPTCHA */}
          <div className="recaptcha-container">
            <ReCAPTCHA sitekey="6LdmugIrAAAAAIblFaSnd474Ym5XSsEioE15plUv" onChange={handleCaptcha} />
          </div>

          <button type="submit" className="submit-btn">Submit</button>
        </form>

        {status && <p className="form-status">{status}</p>}
      </div>
    </div>
  );
};

export default ContactForm;
